export default "__VITE_ASSET__BuyfIlBF__"